import { render, staticRenderFns } from "./a-canvas-bars.vue?vue&type=template&id=226e759c&scoped=true"
import script from "./a-canvas-bars.vue?vue&type=script&lang=js"
export * from "./a-canvas-bars.vue?vue&type=script&lang=js"
import style0 from "./a-canvas-bars.vue?vue&type=style&index=0&id=226e759c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e759c",
  null
  
)

export default component.exports